import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export function HreflangManager() {
  const { i18n } = useTranslation();
  const baseUrl = 'https://kauwenofspauwen.be';

  useEffect(() => {
    // Remove existing hreflang tags
    const existingHreflangs = document.querySelectorAll('link[hreflang]');
    existingHreflangs.forEach(tag => tag.remove());

    // Get the path without language prefix
    const pathname = window.location.pathname;
    const pathWithoutLang = pathname.replace(/^\/[a-z]{2}(\/|$)/, '/');
    const normalizedPath = pathWithoutLang === '/' ? '' : pathWithoutLang;

    // Create hreflang tags for all languages
    const languages = ['en', 'nl', 'fr'];
    languages.forEach(lang => {
      const link = document.createElement('link');
      link.rel = 'alternate';
      link.hreflang = lang;
      link.href = `${baseUrl}/${lang}${normalizedPath}`;
      document.head.appendChild(link);
    });

    // Add x-default pointing to English
    const defaultLink = document.createElement('link');
    defaultLink.rel = 'alternate';
    defaultLink.hreflang = 'x-default';
    defaultLink.href = `${baseUrl}/en${normalizedPath}`;
    document.head.appendChild(defaultLink);

    // Update HTML lang attribute
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);

  return null;
}
